/* Fabric Alex — Izprati multilingual placement + mobile polish. Unpublished theme only. */
(function () {
  'use strict';

  var MODAL_SELECTOR = '.octava-checkout-modal';
  var JOURNEY_SELECTOR = '[data-fa-izprati-journey="true"]';
  var PROVIDER_CLASS = 'fa-izprati-provider-badge';
  var POLISH_STYLE_ID = 'fa-izprati-mobile-polish-style';

  function installMobilePolishStyle() {
    if (document.getElementById(POLISH_STYLE_ID)) return;

    var style = document.createElement('style');
    style.id = POLISH_STYLE_ID;
    style.textContent = [
      '@media screen and (max-width:749px){',
      'html body .octava-checkout-modal .fa-izprati-journey--top .fa-izprati-progress__label{font-size:12px!important;line-height:1.16!important;letter-spacing:-.005em!important;}',
      'html body .octava-checkout-modal .fa-izprati-journey--top .fa-izprati-progress__meta{display:block!important;font-size:10px!important;line-height:1.18!important;color:#5f7082!important;}',
      'html body .octava-checkout-modal .fa-izprati-journey--top .fa-izprati-journey__status{font-size:10px!important;line-height:1.25!important;}',
      '.octava-checkout-modal .octava-checkout-right{display:none!important;}',
      '.octava-checkout-modal .octava-checkout-left{width:100%!important;max-width:none!important;flex:1 1 100%!important;}',
      '}',
      '@media screen and (max-width:390px){',
      'html body .octava-checkout-modal .fa-izprati-journey--top .fa-izprati-progress__meta{display:none!important;}',
      '}'
    ].join('');

    (document.head || document.documentElement).appendChild(style);
  }

  function normalize(value) {
    return String(value || '').replace(/\s+/g, ' ').trim().toLowerCase();
  }

  function fieldSignature(field) {
    return normalize([
      field.getAttribute('type'),
      field.getAttribute('name'),
      field.getAttribute('id'),
      field.getAttribute('placeholder'),
      field.getAttribute('autocomplete'),
      field.getAttribute('aria-label')
    ].join(' '));
  }

  function looksLikeContactField(field) {
    var s = fieldSignature(field);
    return /(^|\s|[-_])(phone|tel|email|first.?name|last.?name|given.?name|family.?name)(\s|$|[-_])/.test(s) ||
      s.indexOf('телефон') !== -1 ||
      s.indexOf('имейл') !== -1 ||
      s.indexOf('e-mail') !== -1 ||
      s.indexOf('собствено име') !== -1 ||
      s.indexOf('фамилно име') !== -1;
  }

  function closestSection(field) {
    return field.closest('.octava-form-section') ||
      field.closest('[class*="form-section"]') ||
      field.closest('[class*="section"]');
  }

  function findContactSection(modal) {
    var inputs = modal.querySelectorAll('input,select,textarea');
    var scores = [];

    Array.prototype.forEach.call(inputs, function (field) {
      if (!looksLikeContactField(field)) return;
      var section = closestSection(field);
      if (!section) return;

      var existing = null;
      Array.prototype.some.call(scores, function (item) {
        if (item.section === section) {
          existing = item;
          return true;
        }
        return false;
      });

      if (existing) existing.score += 1;
      else scores.push({ section: section, score: 1 });
    });

    scores.sort(function (a, b) { return b.score - a.score; });
    if (scores.length && scores[0].score >= 2) return scores[0].section;

    var sections = modal.querySelectorAll('.octava-form-section,[class*="form-section"]');
    var fallback = null;
    Array.prototype.some.call(sections, function (section) {
      var text = normalize(section.textContent);
      if (
        text.indexOf('contact') !== -1 ||
        text.indexOf('данни за доставка') !== -1 ||
        text.indexOf('контакт') !== -1
      ) {
        fallback = section;
        return true;
      }
      return false;
    });
    return fallback;
  }

  function placeJourney(modal) {
    var journey = modal.querySelector(JOURNEY_SELECTOR);
    var contactSection = findContactSection(modal);
    if (!journey || !contactSection || !contactSection.parentElement) return;

    var host = contactSection.parentElement;
    journey.classList.add('fa-izprati-journey--top');

    if (journey.parentElement !== host || journey.nextElementSibling !== contactSection) {
      host.insertBefore(journey, contactSection);
    }

    host.classList.add('fa-izprati-stack-host');
  }

  function hideProviderBranding(modal) {
    var nodes = modal.querySelectorAll('div,span,p,a');
    Array.prototype.forEach.call(nodes, function (node) {
      var text = normalize(node.textContent);
      if (text.length > 140) return;

      var providerLead = text.indexOf('powered by') !== -1 || text.indexOf('работи с') !== -1;
      var providerName = text.indexOf('izprati') !== -1 || text.indexOf('изпрати') !== -1;
      if (providerLead && providerName) node.classList.add(PROVIDER_CLASS);
    });

    Array.prototype.forEach.call(modal.querySelectorAll('img'), function (img) {
      var signature = normalize((img.getAttribute('src') || '') + ' ' + (img.getAttribute('alt') || ''));
      if (signature.indexOf('izprati') === -1 && signature.indexOf('изпрати') === -1) return;

      var parent = img.parentElement;
      for (var i = 0; parent && i < 4; i += 1, parent = parent.parentElement) {
        var text = normalize(parent.textContent);
        if (text.indexOf('powered by') !== -1 || text.indexOf('работи с') !== -1) {
          parent.classList.add(PROVIDER_CLASS);
          break;
        }
      }
    });
  }

  function scan() {
    installMobilePolishStyle();
    Array.prototype.forEach.call(document.querySelectorAll(MODAL_SELECTOR), function (modal) {
      placeJourney(modal);
      hideProviderBranding(modal);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan);
  else scan();

  var queued = false;
  new MutationObserver(function () {
    if (queued) return;
    queued = true;
    window.requestAnimationFrame(function () {
      queued = false;
      scan();
    });
  }).observe(document.documentElement, { childList: true, subtree: true });

  window.setTimeout(scan, 250);
  window.setTimeout(scan, 700);
  window.setTimeout(scan, 1400);
  window.setTimeout(scan, 2600);
})();
